import VSpace from "../components/common/VSpace"
import ProposalSettings from "../components/settings/proposals/ProposalSettings"

const ProposalSettingsPage = () => {
  return <div style={{backgroundColor: 'white'}}>
    <VSpace>
      <div style={{fontSize: '24px', fontWeight: 'bold', padding: '20px'}}>Proposal Settings</div>
      <ProposalSettings />
    </VSpace>
  </div>
}

export default ProposalSettingsPage
